"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveClassificationsMutation = exports.useFetchLuamDataQuery = exports.luamApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.luamApi = (0, react_1.createApi)({
    reducerPath: "luamApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["luam"],
    endpoints: function (builder) { return ({
        fetchLuamData: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/luam",
                    method: "GET",
                    params: __assign({ clientId: clientId }, (buildingId ? { buildingId: buildingId } : {})),
                });
            },
            providesTags: ["luam"],
            /*
             * This read reaches the metering company live, and the prompt that carries it sits on four busy
             * screens. Holding the result for five minutes means moving between those screens costs one
             * provider round trip, not one per page. The LUAM screen itself asks for fresher data.
             */
            keepUnusedDataFor: 300,
        }),
        // Batched: one Save button covers every row in the section, so a press lands completely or not at all.
        saveClassifications: builder.mutation({
            query: function (body) { return ({ url: "/v1/luam/classifications", method: "PATCH", body: body }); },
            invalidatesTags: ["luam"],
        }),
    }); },
});
exports.useFetchLuamDataQuery = exports.luamApi.useFetchLuamDataQuery, exports.useSaveClassificationsMutation = exports.luamApi.useSaveClassificationsMutation;
